module.exports = __webpack_public_path__ + "Flag-562.df8df5bafe0cff382f6f0a41c2fdd0f4.svg";